import React, { createRef } from 'react';
import messages from './Messages';
import {
  EditorHeader,
  SmartScheduleIcon,
  TaskOptions,
  TaskOptionsIcon,
  UploadFileProgressContainer,
  UploadFileRow,
} from './styles';
import { connect, MapStateToProps } from 'react-redux';
import { HideOnMobile } from '../../utils/style/extendable';
import MentionPop from '../MentionPop/MentionPop';
import { ITask } from 'store/tasks/tasksType';
import { IPermission } from 'store/entity/IPermission';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { ITasks, RootState, IUsers, appDispatch } from 'store/store';
import Button from 'components/Button';
import {
  convertDigitToProperFormat,
  convertNumbersToProperFormat,
} from '../../utils/number';
import { black, green, red } from '../../utils/style/colors';
import SanitizedHTML from 'react-sanitized-html';
import { ChipContainer } from '../Chip/Chip';
import Badge from '../Badge';
import Icon from 'components/Icon';

import Textarea from 'components/Textarea';
import Popover from 'components/Popover';
import cloneDeep from 'lodash/cloneDeep';
// import {
//   IMessageViewServer,
//   sendMessage,
// } from '../../store/messages/messagesSlice';
import Spinner from '../Spinner';
import { Menu, MenuItem } from '../Dropdown/styles';
import Dropdown from '../Dropdown';
import i18n, { languageDirection } from '../../i18n';
import notify, { notifyError } from '../Notify/Notify';
import APopover from '../APopover/APopover';
import { summerizeText } from '../../utils/summerizeText';
import LocalIcon from '../../ui/LocalIcon';
import UserProgress from './UserProgress';
import BlurModal from 'containers/Profile/Panels/DocumentManager/BlurModal';
import SmartSchedule, { IScheduleActiveTab } from './SmartSchedule';
import { createPortal } from 'react-dom';
import ProgressBar from 'components/ProgressBar';
import { addTaskAttachement } from 'store/tasks/tasksSlice';
import { jitsiUrl } from '../../api/ManApi';

interface ITaskEditorOwnProps {
  projectName: string;
  task?: ITask;
  companyId?: number;
  embedded?: boolean;
  conversationPanelToggle?: (shouldShow: boolean) => void;
  onCancel: (prop?: any) => void;
  scrollToSubtask: () => void;
  permission: IPermission;
  isCompanyAdmin: boolean;
  isCompanySupport: boolean;
  onPrintSingleTask: () => void;
  handleSaveTask: (task: ITask) => Promise<any>;
  handleClickOnEdit: () => void;
  editing?: boolean;
  parentId?: number;
  onArchiveOrRestoring: (
    type: 'archive' | 'restore',
    taskId: number
  ) => Promise<void>;
  onShowPreferencesModal: (visibility: boolean) => void;
  onDuplicateTask: () => void;
  sendMessageToAssignee: (message: string) => Promise<any>;
  tasks: ITasks;
  users: IUsers;
  hideClose?: boolean;
  templateId: number;
  onRestoreTask: (taskId: number, taskName: string) => Promise<any>;
  userId: number;
  onFileUploaded: () => Promise<any>;
  conversationToken?: string;
  onDeleteTask: (taskId: number, taskName: string) => Promise<any>;
  onDraftTask: (task: ITask) => Promise<void>;
  onChangeProgress?: (
    userId: number,
    progress: number,
    status: any,
    progressDescription: string,
    valueOverwrite?: { [key: string]: string }
  ) => void;
  onSetAssigneeIdToShow: (asId: number | null) => void;
}
interface StateToProps {
  thisUser: IThisUserState;
}
type ITaskEditorHeaderProps = StateToProps & ITaskEditorOwnProps;

interface IUploadedFile {
  fileName?: string;
  progress?: number;
}

interface ITaskEditorHeaderState {
  showFilePickerModal: boolean;
  toSendMessages?: string;
  sendingMessage?: boolean;
  os: string;
  unlockingTask?: boolean;
  restoringTask?: boolean;
  isLoading: boolean;
  deletingTask?: boolean;
  draftingTask?: boolean;
  showSettingsDropdown?: boolean;
  uploadedFilesProgress: {
    [key: string]: IUploadedFile;
  };
  showUploadProgressPopover: boolean;
  showSmartScheduleModal: boolean;
  activeTab: IScheduleActiveTab;
}
const videoValidTasks = ['جلسه', 'کمیته', 'دستور جلسه'];
const cloneValidTask = ['برنامه', 'استقرار'];

export const hashCode = function (s: string) {
  return s.split('').reduce(function (a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
};

class TaskEditorHeader extends React.Component<
  ITaskEditorHeaderProps,
  ITaskEditorHeaderState
> {
  fileRef = createRef<HTMLInputElement>();
  getOS = () => {
    const userAgent = window.navigator.userAgent || window.navigator.vendor;
    // Detect iOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    }

    // Detect Android
    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    return 'Android';
  };

  state = {
    showFilePickerModal: false,
    toSendMessages: '',
    sendingMessage: false,
    os: this.getOS(),
    isLoading: false,
    unlockingTask: false,
    restoringTask: false,
    deletingTask: false,
    draftingTask: false,
    showSettingsDropdown: false,
    uploadedFilesProgress: {},
    showUploadProgressPopover: false,
    showSmartScheduleModal: false,
    activeTab: 'timetable' as IScheduleActiveTab,
  };

  handleRestoreTask = () => {
    const task = this.props.task!;
    const taskTitle = `${task.taskName} ${task.textTitle}`;
    const confirm = window.confirm(
      messages.confirmRestoreTask(taskTitle, task.subTasksTitle)
    );
    if (confirm) {
      this.setState({ restoringTask: true });
      this.props.onRestoreTask(task.id, taskTitle).finally(() => {
        this.setState({ restoringTask: false });
      });
    }
  };

  handleClickOnCancel = () => {
    this.props.onCancel();
  };

  handleClickOnSetting = () => {
    this.props.onShowPreferencesModal(true);
  };

  handleArchiveOrRestore = (type: 'archive' | 'restore') => () => {
    const { task, onArchiveOrRestoring } = this.props;
    if (task) {
      const taskTitle = `${task.taskName} ${task.textTitle}`;
      const confirm = window.confirm(
        messages.confirmArchiveATask(
          taskTitle,
          task.subTasksTitle,
          task.archived
        )
      );
      if (confirm) {
        onArchiveOrRestoring(type, task.id);
      }
    }
  };

  handleShowFilePickerModal = () => {
    this.setState((prevState) => ({
      showFilePickerModal: !prevState.showFilePickerModal,
    }));
  };

  onVideoCall = () => {
    if (!this.props.task) return;
    const hash = hashCode(`${this.props.task!.id * this.props.task.projectId}`);
    const roomName = this.props.task.title;
    const myName = this.props.thisUser.name;
    const url = `${jitsiUrl}/rastech-${hash}#userInfo.displayName="${myName}"&config.callDisplayName="${roomName}"&config.defaultLanguage="fa"`;
    window.open(url);
  };

  handleIconClick = () => {
    this.fileRef.current?.click();
  };

  fetchTaskUntilReachCounter = (counter: number, expectedFiles: number) => {
    try {
      if (counter < 10) {
        setTimeout(() => {
          this.props.onFileUploaded().then((res) => {
            const currentFiles =
              res.data.attachments.length ||
              this.props.task?.attachments.length ||
              0;
            if (currentFiles !== expectedFiles) {
              this.fetchTaskUntilReachCounter(++counter, expectedFiles);
            } else {
              this.setState({
                isLoading: false,
                uploadedFilesProgress: {},
                showUploadProgressPopover: false,
              });
            }
          });
        }, 3000);
      } else {
        this.setState({ isLoading: false, showUploadProgressPopover: false });
      }
    } catch (error) {
      notifyError(i18n.t('FileFailedToUpload', { ns: 'taskManager' }));
      this.setState({ isLoading: false, showUploadProgressPopover: false });
    }
  };

  handleAddFile = (event: any) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const expectedFiles =
        files.length + (this.props.task?.attachments.length || 0);
      this.setState({ isLoading: true, showUploadProgressPopover: true });
      try {
        for (const file of files) {
          appDispatch(
            addTaskAttachement({
              taskId: this.props.task!.id,
              file: file,
              onProgressCallback: (progressEvent: any): void => {
                this.setState({
                  uploadedFilesProgress: {
                    ...this.state.uploadedFilesProgress,
                    [`${file.name}_${file.size}`]: {
                      fileName: file.name,
                      progress: Math.round(progressEvent.progress * 100),
                    },
                  },
                });
              },
            })
          );
        }
      } catch (error) {
        console.error('Error uploading files:', error);
        notifyError(i18n.t('FileFailedToUpload', { ns: 'taskManager' }));
      } finally {
        this.fetchTaskUntilReachCounter(0, expectedFiles);
        event.target.value = null;
      }
    }
  };

  handleDeleteTask = () => {
    const { task } = this.props;
    if (!task) return;
    const taskTitle = `${task.taskName} ${task.textTitle}`;
    const confirm = window.confirm(
      messages.confirmDeleteATask(taskTitle, task.subTasksTitle)
    );
    if (confirm) {
      this.setState({ deletingTask: true });
      this.props.onDeleteTask(task.id, taskTitle).finally(() => {
        this.setState({ deletingTask: true });
      });
    }
  };

  handleDraftTask = () => {
    if (!this.props.task) return;
    this.setState({ draftingTask: true });
    this.props.onDraftTask(this.props.task).finally(() => {
      this.setState({ draftingTask: false });
    });
  };

  handChangeSmartScheduleModalStatus = () => {
    this.setState({
      showSmartScheduleModal: !this.state.showSmartScheduleModal,
      activeTab: 'timetable',
    });
  };

  handleOpenTaskProgressModal = () => {
    this.setState({
      showSmartScheduleModal: true,
      activeTab: 'progressDiagram',
    });
  };

  handleDuplicateTask = () => {
    notify(i18n.t('taskIsDuplicating', { ns: 'taskManager' }), 'info');
    this.props.onDuplicateTask();
  };

  render() {
    const {
      task,
      projectName,
      permission,
      onPrintSingleTask,
      companyId,
      tasks,
      hideClose,
    } = this.props;

    const iconClassName =
      task && task.printTemplate
        ? 'myblack-text'
        : 'mygray-text disable-pointer-events';

    let totalProgress = 0;
    if (typeof task?.mainProgress === 'number') {
      totalProgress = task.mainProgress;
    } else if (typeof task?.secondaryProgress === 'number') {
      totalProgress = task.secondaryProgress;
    }

    const showTotalProgress = task?.id && task.taskProgressType.main;

    return (
      <div>
        {this.props.task &&
          this.state.showSmartScheduleModal &&
          createPortal(
            <BlurModal
              isOpen={this.state.showSmartScheduleModal}
              onCloseModal={this.handChangeSmartScheduleModalStatus}
              title={
                i18n.t('smartSchedule', {
                  ns: 'taskManager',
                  projectName: this.props.task.textTitle,
                }) as string
              }
              maxWidth="auto"
            >
              <SmartSchedule
                task={this.props.task}
                companyId={this.props.companyId!}
                onCloseModal={this.handChangeSmartScheduleModalStatus}
                activeTab={this.state.activeTab as IScheduleActiveTab}
              />
            </BlurModal>,
            document.body
          )}
        <EditorHeader>
          <div className="flex flex-col gap-3">
            <div
              style={{
                display: 'flex',
                gap: '4px',
                alignItems: 'center',
                overflow: 'hidden',
                fontWeight: 'bold',
              }}
            >
              <HideOnMobile
                style={{
                  alignItems: 'center',
                  gap: '4px',
                }}
              >
                {(task?.taskName ||
                  tasks.data[Number(this.props.templateId)]?.taskName ||
                  '') +
                  ` ${projectName ? i18n.t('in', { ns: 'taskManager' }) : ''} ` +
                  (projectName || '')}
              </HideOnMobile>
              {!this.props.editing && <HideOnMobile> | </HideOnMobile>}
              {task?.deleteState && (
                <ChipContainer
                  style={{
                    color: red,
                    whiteSpace: 'nowrap',
                    marginTop: '-3px',
                  }}
                  selected={false}
                >
                  {i18n.t('deleted', { ns: 'taskManager' })}
                </ChipContainer>
              )}
              {!this.props.editing && task && (
                <>
                  <SanitizedHTML
                    style={{
                      color: task.deleteState ? red : black,
                    }}
                    html={'<b>' + task.title + '</b>'}
                  />
                  {task?.haveWeight && (
                    <Badge color="black" style={{ width: '5rem' }}>
                      {i18n.t('taskWeight', { ns: 'taskManager' }) +
                        ' : ' +
                        convertDigitToProperFormat(task.weight)}
                    </Badge>
                  )}
                </>
              )}
              {!task && this.props.parentId && (
                <span>
                  {messages.subtaskFor(
                    tasks.data[Number(this.props.parentId)]?.textTitle ||
                      tasks.data[Number(this.props.parentId)]?.title ||
                      '',
                    tasks.data[Number(this.props.templateId)]?.taskName
                  )}
                </span>
              )}
            </div>
            {showTotalProgress && (
              <div className="flex flex-col gap-1">
                <h5 style={{ flex: 1 }}>
                  {task?.mainProgressTitle ||
                    (i18n.t('mainProgressTitle', {
                      ns: 'taskManager',
                    }) as string)}
                </h5>
                <div
                  style={{
                    width: '10rem',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '0.5rem',
                    cursor: 'pointer',
                  }}
                  onClick={this.handleOpenTaskProgressModal}
                >
                  <ProgressBar
                    count={totalProgress}
                    total={100}
                    color={`linear-gradient(to ${languageDirection() === 'rtl' ? 'right' : 'left'}, hsl(${totalProgress * 1.73}, 59%, 49%) 0%, var(--exact-white) 100%);`}
                  />
                  <div
                    style={{
                      width: '4rem',
                      textAlign: 'end',
                      color: black,
                    }}
                  >
                    {i18n.language === 'fa'
                      ? `${convertNumbersToProperFormat(totalProgress, 0)}%`
                      : `${totalProgress.toFixed(0)}%`}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div style={{ flexGrow: 100 }}></div>
          {Object.keys(this.props.task?.assignee || {}).includes(
            this.props.thisUser.userId.toString()
          ) &&
            !this.props.task?.draft && (
              <>
                <UserProgress
                  user={this.props.thisUser}
                  task={this.props.task}
                  canChangeProgress={permission.markSelf}
                  onSetAssigneeIdToShow={this.props.onSetAssigneeIdToShow}
                />
              </>
            )}
          <TaskOptions>
            <span style={{ flex: 1 }} />
            {this.props.task?.haveSubTask &&
              (!task!.draft || !task!.preventSubTaskCreationWhenDraft) && (
                <Button
                  style={{ margin: '0 8px ' }}
                  onClick={() => this.props.scrollToSubtask()}
                >
                  {this.props.task?.subTasksTitle ||
                    (i18n.t('subtasks', { ns: 'taskManager' }) as string)}
                </Button>
              )}
            <MentionPop
              embedded={this.props.embedded}
              mentions={task?.mentions || []}
              companyId={companyId}
              isHoverIcon={true}
              conversationPanelToggle={this.props.conversationPanelToggle}
              projectId={
                window.location.href?.includes('/project/')
                  ? task?.projectId
                  : undefined
              }
            />
            {task && permission.edit && (
              <Popover
                trigger="click"
                placement="bottom"
                overlay={
                  <div>
                    <h5>
                      {messages.sendMessageTo(
                        task.assigneeTitle || messages.assignee
                      )}
                    </h5>
                    <Textarea
                      id={'sendSMS'}
                      value={this.state.toSendMessages}
                      label={i18n.t('enterSMS', { ns: 'taskManager' })}
                      onChange={(e) => {
                        this.setState({ toSendMessages: e.target.value });
                      }}
                      placeholder={i18n.t('enterSMS', { ns: 'taskManager' })}
                    />
                    {/*<div className="hide-on-mobile">*/}
                    {/*  <ButtonGroup*/}
                    {/*    onSelect={(os: string) => {*/}
                    {/*      this.setState({ os });*/}
                    {/*    }}*/}
                    {/*    items={osTypes}*/}
                    {/*    selected={this.state.os}*/}
                    {/*    style={{ marginBottom: '10px' }}*/}
                    {/*  />*/}
                    {/*  <QRCode*/}
                    {/*    style={{ margin: 'auto', width: '100%' }}*/}
                    {/*    value={smsLink}*/}
                    {/*  />*/}
                    {/*  <p>{messages.hint}</p>*/}
                    {/*</div>*/}
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row-reverse',
                      }}
                    >
                      <Button
                        disabled={
                          (this.state.toSendMessages?.trim().length ?? 0) === 0
                        }
                        loading={this.state.sendingMessage}
                        onClick={() => {
                          this.setState({ sendingMessage: true });
                          this.props
                            .sendMessageToAssignee(this.state.toSendMessages)
                            .finally(() => {
                              this.setState({ sendingMessage: false });
                            });
                        }}
                      >
                        <>
                          <Icon type={'send'} />
                          {i18n.t('sendSMS', { ns: 'taskManager' })}
                        </>
                      </Button>
                    </div>
                  </div>
                }
              >
                <TaskOptionsIcon
                  type="message-square"
                  titlePlacement={'top'}
                  title={i18n.t('sendSMS', { ns: 'taskManager' })}
                />
              </Popover>
            )}

            {task && videoValidTasks?.includes(task.taskName) && (
              <TaskOptionsIcon
                type="video"
                titlePlacement={'top'}
                title={i18n.t('videoCall', { ns: 'taskManager' })}
                onClick={this.onVideoCall}
              />
            )}
            {task &&
              (cloneValidTask.some((it) => task.taskName?.includes(it)) ||
                task.allowDuplicate) && (
                <TaskOptionsIcon
                  type="copy"
                  title={i18n.t('duplicate', { ns: 'taskManager' })}
                  onClick={() => this.handleDuplicateTask()}
                />
              )}
            {task && companyId && (
              <>
                <input
                  type="file"
                  ref={this.fileRef}
                  style={{ display: 'none' }}
                  onChange={(event: any) => {
                    this.handleAddFile(event);
                  }}
                  multiple={true}
                />
                {this.state.isLoading ? (
                  <>
                    <APopover
                      trigger="click"
                      target={
                        <Spinner
                          style={{ width: '1.5rem', height: '1.5rem' }}
                        />
                      }
                      show={this.state.showUploadProgressPopover}
                      onShowChange={() =>
                        this.setState({
                          showUploadProgressPopover:
                            !this.state.showUploadProgressPopover,
                        })
                      }
                    >
                      <UploadFileProgressContainer>
                        {Object.entries(this.state.uploadedFilesProgress).map(
                          ([key, item]: [string, any]) => (
                            <UploadFileRow key={key}>
                              <div className="px-1">
                                {item.progress < 100 ? (
                                  <Spinner
                                    style={{
                                      width: '1rem',
                                      height: '1rem',
                                      paddingTop: '0.25rem',
                                    }}
                                  />
                                ) : (
                                  <LocalIcon
                                    iconName={'file-check.svg'}
                                    color={`${green}`}
                                    type={'sm'}
                                  />
                                )}
                              </div>
                              <div>{summerizeText(item.fileName, 50)}</div>
                              <div
                                className="flex-1"
                                style={{ textAlign: 'end' }}
                              >
                                <>
                                  {convertDigitToProperFormat(item.progress)}{' '}
                                  {i18n.t('percent', { ns: 'taskManager' })}
                                </>
                              </div>
                            </UploadFileRow>
                          )
                        )}
                      </UploadFileProgressContainer>
                    </APopover>
                  </>
                ) : (
                  <>
                    {permission.edit && (
                      <TaskOptionsIcon
                        type="file-plus"
                        title={i18n.t('AddAttachments', { ns: 'taskManager' })}
                        onClick={this.handleIconClick}
                      />
                    )}
                  </>
                )}
              </>
            )}
            {task && permission.edit && (
              <SmartScheduleIcon
                type="clock"
                title={i18n.t('smartSchedule', { ns: 'taskManager' }) as string}
                onClick={this.handChangeSmartScheduleModalStatus}
              />
            )}
            {task?.printTemplate && (
              <TaskOptionsIcon
                type="printer"
                title={i18n.t('printTaskIconTitle', { ns: 'taskManager' })}
                onClick={onPrintSingleTask}
                className={iconClassName}
              />
            )}
            {task && !task.deleteState && permission.deleteOrArchive ? (
              task.archived ? (
                <TaskOptionsIcon
                  type="upload"
                  title={i18n.t('restoreTaskIconTitle', {
                    ns: 'taskManager',
                  })}
                  onClick={this.handleArchiveOrRestore('restore')}
                />
              ) : (
                <TaskOptionsIcon
                  type="archive"
                  title={i18n.t('archiveIconTitle', { ns: 'taskManager' })}
                  onClick={this.handleArchiveOrRestore('archive')}
                />
              )
            ) : null}
            {task && permission.edit && (
              <>
                {!task.lockProps && (
                  <Dropdown
                    marginToTarget={4}
                    placement="bottom-end"
                    width={150}
                    show={this.state.showSettingsDropdown}
                    curveBorder={true}
                    onShowChange={(show) => {
                      this.setState({ showSettingsDropdown: show });
                    }}
                    target={
                      <div>
                        <TaskOptionsIcon
                          type="settings"
                          title={i18n.t('taskSettingsIconTitle', {
                            ns: 'taskManager',
                          })}
                        />
                      </div>
                    }
                  >
                    <Menu>
                      {task.deleteState !== 'deleted' && (
                        <>
                          {this.props.isCompanyAdmin && (
                            <MenuItem>
                              <span
                                onClick={() => {
                                  this.props.onShowPreferencesModal(true);
                                  this.setState({
                                    showSettingsDropdown: false,
                                  });
                                }}
                                style={{ display: 'flex', gap: '10px' }}
                              >
                                <Icon type={'move'} color={black} />
                                {messages.moveTask(task.taskName)}
                              </span>
                            </MenuItem>
                          )}
                          {!task.draft &&
                            tasks.data[task.templateId]
                              ?.draft /*otherwise there is no undraft scenario*/ && (
                              <MenuItem>
                                <span
                                  onClick={() => this.handleDraftTask()}
                                  style={{ display: 'flex', gap: '10px' }}
                                >
                                  <Icon
                                    loading={this.state.draftingTask}
                                    type={'edit'}
                                  />
                                  {
                                    i18n.t('draftTask', {
                                      ns: 'taskManager',
                                    }) as string
                                  }
                                </span>
                              </MenuItem>
                            )}
                          <MenuItem>
                            <span
                              onClick={() => this.handleDeleteTask()}
                              style={{ display: 'flex', gap: '10px' }}
                            >
                              <Icon
                                loading={this.state.deletingTask}
                                type={'trash'}
                                color={'red'}
                              />{' '}
                              {messages.deleteTask(task.taskName)}
                            </span>
                          </MenuItem>
                        </>
                      )}
                    </Menu>
                  </Dropdown>
                )}
                {!task.deleteState &&
                  (task.lockProps ? (
                    <TaskOptionsIcon
                      type="lock"
                      title={messages.taskIsLocked(
                        task.taskName,
                        this.props.permission.unlock
                      )}
                      loading={this.state.unlockingTask}
                      style={{ margin: '0 0.3em' }}
                      onClick={() => {
                        if (this.props.permission.unlock) {
                          if (
                            window.confirm(messages.unlockTask(task.taskName))
                          ) {
                            this.setState({ unlockingTask: true });
                            const clone = cloneDeep(this.props.task) as ITask;
                            clone.lockProps = false;
                            this.props
                              .handleSaveTask(clone)
                              .then(() => {
                                // notify(messages.taskUnlocked(task?.taskName));
                              })
                              .finally(() => {
                                this.setState({ unlockingTask: false });
                              });
                          }
                        }
                      }}
                    />
                  ) : (
                    <TaskOptionsIcon
                      type="edit"
                      title={i18n.t('editTask', { ns: 'taskManager' })}
                      onClick={this.props.handleClickOnEdit}
                    />
                  ))}
                {task.deleteState && (
                  <TaskOptionsIcon
                    type="rotate-ccw"
                    title={messages.restoreTaskIconTitle}
                    color={red}
                    style={{ margin: '0 0.3em' }}
                    loading={this.state.restoringTask}
                    onClick={this.handleRestoreTask}
                  />
                )}
              </>
            )}

            {!hideClose && (
              <LocalIcon
                iconName={'close-square.svg'}
                type={'sm'}
                color={'no-color'}
                isLink={true}
                onClick={this.handleClickOnCancel}
                title={i18n.t('close', { ns: 'taskManager' })}
              />
            )}
          </TaskOptions>
          {/*</div>*/}
        </EditorHeader>
      </div>
    );
  }
}
const mapStateToProps: MapStateToProps<
  StateToProps,
  ITaskEditorOwnProps,
  RootState
> = (state) => {
  const thisUser = state.thisUser;

  return { thisUser };
};

export default connect(mapStateToProps)(TaskEditorHeader);
